import SurveyComponent from './SurveyComponent';

function App(): React.ReactElement {
  return <SurveyComponent />;
}

export default App;
